// extracted by mini-css-extract-plugin
export default {"info-control__wrap":"InformationControl_info-control__wrap__VZwsZ","-name":"InformationControl_-name__IG2cQ","-value":"InformationControl_-value__gdJnP"};